import CompilationCardComponent from '@/frontend/components/CompilationCardComponent';
import EmptyResultComponent from '@/frontend/components/EmptyResultComponent';
import SpinnerComponent from '@/frontend/components/SpinnerComponent';
import CompilationsApi from '@/frontend/api/compilations';
export default {
  name: "CompilationsPage",
  components: {
    CompilationCardComponent,
    EmptyResultComponent,
    SpinnerComponent
  },
  props: ['q'],

  data() {
    return {
      compilations: [],
      compilationRequestParams: {},
      PaginationMeta: {
        currentPage: 1,
        pageCount: 1
      },
      compilationsLoader: {
        load: false,
        title: 'Пусто',
        description: 'Нет подборок, соответствующих заданным параметрам отбора'
      },
      scroll: {
        x: 0,
        y: 0
      }
    };
  },

  methods: {
    requestCompilations() {
      this.compilationRequestParams['filter[name][like]'] = this.q;
      CompilationsApi.getUnion(this.compilationRequestParams).then(response => {
        this.compilations = this.compilations.concat(response.items);
        this.PaginationMeta = response._meta;
      }).finally(() => this.compilationsLoader.load = true);
    },

    changePage() {
      let number;
      if (!this.compilationsLoader.load) return;
      number = ++this.PaginationMeta.currentPage;
      if (number < 1 || this.PaginationMeta.pageCount && number > this.PaginationMeta.pageCount) return;
      this.compilationsLoader.load = false;
      this.PaginationMeta.currentPage = number;
      this.compilationRequestParams.page = number;
      this.requestCompilations();
    },

    handleScroll() {
      if (window.scrollY + window.innerHeight >= this.$refs.catalog.offsetTop + this.$refs.catalog.clientHeight) {
        this.compilations.length && this.changePage();
      }
    }

  },

  created() {
    this.compilationRequestParams = {
      fields: ['id', 'name', 'thumbWithPath'].join(','),
      'per-page': 21,
      page: this.PaginationMeta.currentPage
    };
    this.requestCompilations();
  },

  activated() {
    window.scroll(this.scroll.x, this.scroll.y);
    window.addEventListener('scroll', this.handleScroll);
  },

  deactivated() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  beforeRouteLeave() {
    this.scroll.x = window.scrollX;
    this.scroll.y = window.scrollY;
  }

};